import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { api } from '../config';
import './NotificationsPage.css';

  // Utility to check if token is expired
function isTokenExpired(token) {
    if (!token) return true;
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (!payload.exp) return true;
      return Date.now() >= payload.exp * 1000;
    } catch  {
      return true;
    }
  }
  
  const NotificationsPage = () => {
    const { accessToken, isLoggedIn } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);
    const [notifications, setNotifications] = React.useState([]);

useEffect(() => {
  const fetchNotifications = async () => {
    try {
      const res = await fetch(api.url('/api/notifications'), {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (res.ok) {
        const data = await res.json();
        setNotifications(data);
      } else {
        // Silent failure in production:
        setNotifications([]);
      }
    } catch {
      // Silent in production:
      setNotifications([]);
    }
  };

  if (isLoggedIn && !isTokenExpired(accessToken)) {
    fetchNotifications();
  }
}, [isLoggedIn, accessToken]);

    // 🔒 Redirect to login if not authenticated
    useEffect(() => {
      if (!isLoggedIn || isTokenExpired(accessToken)) {
        navigate('/login', { state: { from: location.pathname } });
      }
    }, [accessToken, isLoggedIn, navigate, location.pathname]);
    function groupNotificationsByDate(notifications) {
        const groups = {};
      
        notifications.forEach((notif) => {
          const date = new Date(notif.createdAt);
          const today = new Date();
          const yesterday = new Date();
          yesterday.setDate(today.getDate() - 1);
      
          const notifDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
          const todayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
          const yestDate = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate());
      
          let label;
      
          if (notifDate.getTime() === todayDate.getTime()) {
            label = 'Today';
          } else if (notifDate.getTime() === yestDate.getTime()) {
            label = 'Yesterday';
          } else {
            label = date.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
          }
      
          if (!groups[label]) {
            groups[label] = [];
          }
          groups[label].push(notif);
        });
      
        return groups;
      }
      
  return (
    <div className="notifications-page">
      <div className="header">
            <div className="brand" onClick={() => navigate("/")}>
            <img src="/images/customroam-logo.png" alt="Logo" className="logo-img" />
            <span className="brand-text">CUSTOM ROAM</span>
             </div>
              {/* Hamburger menu button */}
              <button className="header-menu-btn" onClick={() => setMenuOpen(!menuOpen)}>
                ☰
               </button>
             <div className={`nav-links ${menuOpen ? 'open' : ''}`}>
                    <span className="nav-link" onClick={() => navigate('/')}>Home</span>
                    <span className="nav-link" onClick={() => navigate('/roam-share')}>Roam Share</span>
                    <span className="nav-link" onClick={() => navigate('/my-itineraries')}>My Itineraries</span>
                    <span className="notification-icon" onClick={() => navigate('/notifications')}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                       height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                     className="bell-svg"
                    >
                        <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"></path>
                         <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                    </svg>
                 </span>
                    <span className="nav-link" onClick={() => navigate('/profile')}>Profile</span>
                </div>
            </div>
      <ul className="notification-list">
        <h2>Notifications</h2>
        {Object.entries(groupNotificationsByDate(notifications)).map(([dateGroup, items]) => (
  <div key={dateGroup} className="notification-group">
    <h3 className="notification-date-heading">📅 {dateGroup}</h3>
    <ul className="notification-sublist">
      {items.map((notification) => (
        <li key={notification.id} className="notification-item">
  <div className="notification-content">
    <div className="notification-text-wrap">
      <div className="notification-message">{notification.message}</div>
      <div className="notification-time">
        {new Date(notification.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
      </div>
    </div>

    {notification.type === "like" && notification.postPreviewUrl && (
      <img
        src={notification.postPreviewUrl}
        alt="Post preview"
        className="notification-preview-img"
      />
    )}

    {notification.type === "like" && !notification.postPreviewUrl && notification.postVideoUrl && (
      <div className="notification-video-preview">▶</div>
    )}
  </div>
</li>
      ))}
    </ul>
  </div>
))}

  </ul>
    </div>
  );
};

export default NotificationsPage;
